import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { CommentChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class CommentChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): CommentChartData {

    const totalCommentsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.comment.total.day || {},
        aggregationLevel,
      );

    const commentsAddedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.comment.added) || {},
        aggregationLevel,
      );

    return {
      totalComments: totalCommentsData,
      added: commentsAddedData,
    };
  }

}
